import { render, staticRenderFns } from "./IntroProductChooseModal.vue?vue&type=template&id=b3c3dd78&scoped=true"
import script from "./IntroProductChooseModal.vue?vue&type=script&lang=js"
export * from "./IntroProductChooseModal.vue?vue&type=script&lang=js"
import style0 from "./IntroProductChooseModal.vue?vue&type=style&index=0&id=b3c3dd78&prod&lang=scss&scoped=true"
import style1 from "./IntroProductChooseModal.vue?vue&type=style&index=1&id=b3c3dd78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c3dd78",
  null
  
)

export default component.exports